/**
 * 차트 관련 UI 문자열 리소스
 * chart-view, chart-options, indicator-legend 등
 */
export const chartStr = {
  options: {
    title: '차트 설정',
    autoScale: 'Y축 자동 스케일링 사용',
    showIndicatorValue: 'Y축에 지표 값 표시',
    subChartMinHeight: '서브 차트 최소 높이',
    subChartMaxHeight: '서브 차트 최대 높이',
  },
  legend: {
    hide: '숨김',
    config: '설정',
    delete: '삭제',
    expand: '펼치기',
    collapse: '접기',
    indicatorLegend: '지표 범례 {action}',
  },
  indicator: {
    selectTitle: '지표 선택',
  },
  orderTooltip: {
    manual: '수동',
    time: '시간',
    amount: '금액',
    orderPrice: '주문 시점 가격 기준',
    profit: '수익',
    profitRate: '수익률',
    netProfit: '순익',
    netProfitRate: '순익률',
    signalPrice: '신호 발생 시 수신 가격 기준',
    smoothedPrice: '신호 발생 시 평균 가격 기준',
    splitStep: '분할 매매 단계 {step}',
    direction: '방향',
    entryRatio: '{orderType} 비율',
  },
};
